import { SystemLabel } from './system-label';

export class LowStockSystemLabel extends SystemLabel {}
